/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { Label } from "reactstrap";
import ModalDialog from "../../elements/ModalDialog";
import Media from "../../elements/Media";
import { secondsToTimeString, unixEpochToString } from "../../util/DateTime";
import { addressToString } from "../../util/Address";

export const SummaryLabel = ({title, value, placeholder = "None"}) => {
  return (
    <div className="d-flex">
      <Label className="flex-static pe-1">{title}:</Label>
      {value ? (
        <Label className="flex-dynamic fw-bold">{value}</Label>
      ) : (
        <Label className="flex-dynamic text-muted">{placeholder}</Label>
      )}
    </div>
  );
};

export const SummaryTimeLabel = ({title, prefix, value, suffix}) => {
  // parse out time
  let string = secondsToTimeString(value);

  // add prefix / suffix
  if (value) {
    if (prefix) {
      string = prefix + " " + string;
    }
    if (suffix) {
      string = string + " " + suffix;
    }
  }

  return <SummaryLabel title={title} value={string} />
};

export const SummaryDateLabel = ({title, timestamp}) => {
  return <SummaryLabel title={title} value={unixEpochToString(timestamp)} />
};

export const SummaryListLabel = ({title, values, placeholder}) => {
  let aggregate = ""

  if (values != null) {
    values.forEach((value, index) => {
      if (index > 0) {
        aggregate += ", ";
      }
      aggregate += value;
    });
  }

  return <SummaryLabel title={title} value={aggregate} placeholder={placeholder} />
};

export const AddressSummaryLabel = ({title, address}) => {
  const locationString = addressToString(address);

  return (
    <div className="d-flex">
      <Label className="flex-static pe-1">{title}:</Label>
      {locationString ? (
        <div className="d-flex">
          <Label className="flex-dynamic fw-bold">{locationString}</Label>
          <Label className="flex-static ps-2">(Timezone: {address.realTimezone ?? address.timezone ?? ""})</Label>
        </div>
      ) : (
        <Label className="flex-dynamic text-muted">None</Label>
      )}
    </div>
  );
};

export const CheckboxSummaryLabel = ({title, checked, placeholder = "Inherit Parent"}) => {
  const isEmpty = checked == null;

  return (
    <div className="d-flex">
      <Label className="pe-1">{title}:</Label>
      {isEmpty ? (
        <Label className="flex-dynamic text-muted">{placeholder}</Label>
      ) : (
        <i className={`icon ${checked ? "bi-check-square" : "bi-square"}`} />
      )}
    </div>
  );
};

export const MediaSummaryLabel = ({title, url}) => (
  <div>
    <Label className="pe-1">{title}:</Label>
    {url ? (
      <ModalDialog className="link-primary clickable" text="View" size="lg" hideCard>
        <div className="d-flex align-items-center justify-content-center">
          <Media
            src={url}
            alt="Unable to load"
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          >
            <Label className="mb-3" tag="h5">Unable to load media</Label>
          </Media>
          </div>
      </ModalDialog>
    ) : (
      <Label className="text-muted fw-light">None</Label>
    )}
  </div>
);
